import { StyledIcon } from 'src/components/foundations/foundations.styles';
import {
  Article,
  ArticleHelpText,
  ArticlesList,
  SuggestedReadingWrapper,
  ArticlesTitle,
} from './SuggestedReading.styles';
import { Divider, Link } from 'src/components/atoms';
import { useTheme } from 'styled-components';

interface Props {
  articles: { title: string; link: string }[];
}

export const SuggestedReading = (props: Props) => {
  const theme = useTheme();
  return (
    <SuggestedReadingWrapper>
      <ArticlesTitle>SUGGESTED READING</ArticlesTitle>
      <ArticlesList>
        {props.articles.map((article) => (
          <Article key={article.title}>
            <StyledIcon className="uil uil-file-alt" size="24px" />
            <Link
              href={article.link}
              target="_blank"
              rel="noopener noreferrer"
              size="medium"
              color={
                theme.isVaultVariant
                  ? theme.newPalette.neutral.N800
                  : theme.atlas.semantic.color.type.default
              }
            >
              {article.title}
            </Link>
          </Article>
        ))}
      </ArticlesList>
      <Divider variant="horizontal" />
      <ArticleHelpText>
        Experiencing an issue or unable to locate what you&apos;re looking for?
        Reach out via Technical Support and we&apos;ll be happy to assist you.
      </ArticleHelpText>
    </SuggestedReadingWrapper>
  );
};
